module.exports = __webpack_public_path__ + "img/setor-costura-acao-camisetas.b2c66311.png";